import { Country } from "./countryData";

interface Continent {
  id: number;
  continent: string;
  imageUrl: string;
  countryIds: number[];
  countries: Country[]; // Ensure this is always an array
}

export const continents: Continent[] = [
  {
    id: 1,
    continent: "Asia",
    imageUrl: "/Continent/Asia.webp",
    countryIds: [1,2], // Example country IDs
    countries: [], // Initialize as an empty array
  },

  // {
  //   id: 2,
  //   continent: "Caribbean",
  //   imageUrl: "/Continent/CB.webp",
  //   countryIds: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21], // Example country IDs
  //   countries: [], // Initialize as an empty array
  // },

  // {
  //   id: 3,
  //   continent: "Africa",
  //   imageUrl: "/Continent/Africa.webp",
  //   countryIds: [22,23], // Example country IDs
  //   countries: [], // Initialize as an empty array
  // },

];
